const User = () => import('@/modules/users/views/User.vue')
const UserProfile = () => import('@/modules/users/views/UserProfile.vue')
const UserFollows = () => import('@/modules/users/views/UserFollows.vue')
const UserSettings = () => import('@/modules/users/views/UserSettings.vue')
const UserDrafts = () => import('@/modules/users/views/UserDrafts.vue')
const UserOngoing = () => import('@/modules/users/views/UserOngoing.vue')

const userFollowsRoutes = [
  {
    path: '/:username/following',
    name: 'following.index',
    component: UserFollows
  },
  {
    path: '/:username/followers',
    name: 'followers.index',
    component: UserFollows
  }
]

const userRoutes = [
  {
    path: '/drafts',
    name: 'users.drafts',
    component: UserDrafts,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/ongoing',
    name: 'users.ongoing',
    component: UserOngoing,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/settings',
    name: 'settings.show',
    component: UserSettings,
    meta: { requiresAuthentication: true }
  },
  {
    component: User,
    path: '/:username',
    children: [
      {
        path: '/',
        name: 'users.show',
        component: UserProfile
      }
    ]
  }
]

export {
  userFollowsRoutes,
  userRoutes
}
